import * as types from '../constants/actionTypes';

export const defaultState = {
  loading: false,
  result: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case types.FETCH_SERIES:
      return {
        ...state,
        loading: false,
      };
    case types.FETCH_SERIES_ERROR:
      return {
        ...state,
        loading: false,
      };
    case types.FETCH_SERIES_LOADING:
      return {
        ...state,
        loading: true,
      };
    case types.FETCH_SERIES_SUCCESS:
      return {
        ...state,
        result: action.data.map(ser => ({ slug: ser.name, value: ser.name })),
        loading: false,
      };
    default:
      return state;
  }
};
